import Vue from 'vue';
import Vuetify from 'vuetify/lib';
//import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
          light: {
            "tablet-list-background": "#FAFAFA",
            "themeColorA": "#2a4054",
            "themeColorB": "#54442a",
            "themeColorC": "#542f2a",
            "themeColorD": "#2a543e"
          },
          dark: {
            "tablet-list-background": "#1e1e1e",
            "themeColorA": "#2a4054",
            "themeColorB": "#54442a",
            "themeColorC": "#542f2a",
            "themeColorD": "#2a543e",

            //info: colors.blueGrey, 
            // success: colors.green, 
            // error: "#FF5252"
          }
        }
      },
});